import type * as Types from 'app/types/graphql';

export type ArticleEdgeSelectFragment = {
  node?: Types.Maybe<
    Pick<Types.Article, 'baseID' | 'title' | 'handle' | 'publishedAt' | 'templateSuffix'> & {
      blogs?: Types.Maybe<{
        edges: Array<{ node?: Types.Maybe<Pick<Types.Blog, 'handle' | 'baseID'>> }>;
      }>;
      media?: Types.Maybe<Pick<Types.Media, 'src'>>;
    }
  >;
};

export type ArticleSelectFragment = Pick<
  Types.Article,
  'baseID' | 'title' | 'handle' | 'publishedAt' | 'templateSuffix'
> & {
  blogs?: Types.Maybe<{
    edges: Array<{ node?: Types.Maybe<Pick<Types.Blog, 'handle' | 'baseID'>> }>;
  }>;
  media?: Types.Maybe<Pick<Types.Media, 'src'>>;
};

export const ArticleSelectFragmentDoc = `
    fragment ArticleSelect on Article {
  baseID
  title
  handle
  publishedAt
  templateSuffix
  blogs {
    edges {
      node {
        handle
        baseID
      }
    }
  }
  media {
    src
  }
}
    `;
export const ArticleEdgeSelectFragmentDoc = `
    fragment ArticleEdgeSelect on ArticleEdge {
  node {
    ...ArticleSelect
  }
}
    `;
